import type {
  InstructionsChart5Setting,
  InstructionsChartOption,
} from '@app-types/instructions';

const normalizedPublicUrl = (process.env.PUBLIC_URL ?? '').replace(/\/$/, '');

/** Static Chart5 artifact copied into CRA's public output. */

// export const INSTRUCTIONS_CHART_BUNDLE_URL =
//   `${normalizedPublicUrl}/chart-bundle/index.html`;

  export const INSTRUCTIONS_CHART_BUNDLE_URL =
  `${normalizedPublicUrl}/build/index.html`;

/** Defaults verified against the supplied mobile bundle source map. */
export const INSTRUCTIONS_CHART5_SETTING: InstructionsChart5Setting = {
  // Requested latest-price tracker color. The supplied artifact currently
  // hardcodes the top-level tracker off; keep the host contract ready for the
  // corrected child bundle without patching generated assets.
  priceTrackColor: '3F9F3F',
  // Figma: only the latest-price tracker value text is white; the slate axis
  // labels stay 67727A via toolTipsColor below.
  priceTrackFontColor: 'FFFFFF',
  priceTrackThinkness: 2,
  priceTrackStyle: 'd',
  yAsis: false,
  backgroundColor: 'FFFFFF',
  chartBackgroundColor: 'FFFFFF',
  chartLineColor: 'C6D1CC',
  chartLineStyle: 's',
  toolTipsColor: '67727A',
  crosshairLineColor: '444444',
  crosshairLineStyle: 's',
  crosshairPointColor: 'FF0000',
  crosshairPointSize: '0',
  crosshairFontColor: 'FFFFFF',
};

/** Complete line-chart option shape expected by the bundle. */
export const INSTRUCTIONS_CHART_OPTION: InstructionsChartOption = {
  lineColor: '2352D6',
  lineFillColor: '2352D6',
  lineFillColor2: 'FFFFFF',
  // Enables the bundle's blue-to-white vertical area fill below the price line
  // (Figma reference). The bundle only builds fillColor/fillColor2 when true.
  lineGradientEnable: true,
  lineStyle: 's',
  lineThickness: 2,
  upColor: 'FF0055',
  upFillColor: 'FF0055',
  downColor: '12DDD6',
  downFillColor: '12DDD6',
  barColor: '3386FF',
  bar3lineColor: '3386FF',
  histogramUpColor: 'DDDDDD',
  histogramUpFillColor: '99CCFF',
  histogramDownColor: 'DDDDDD',
  histogramDownFillColor: '99CCFF',
  showTracker: true,
};
